import _ from 'lodash';

// format: ###-##-###
export const numberFormat =
  (format: string, splitChar: string, prefixChar?: string) =>
  (value: string) => {
    if (!value) {
      return value;
    }

    if (!_.isString(format)) {
      return value;
    }

    let _value = value;
    if (prefixChar && value.endsWith(prefixChar)) {
      return '';
    }

    if (prefixChar && value.startsWith(prefixChar)) {
      _value = value.substring(prefixChar.length);
    }

    // convert '123-345-667' to '123345667'
    _value = _value.replace(/[^\d]/g, '');

    let result = format
      .split(splitChar)
      .map((o) => o.length)
      .reduce(
        (acc: { value: string; arr: string[] }, len: number) => {
          return {
            value: acc.value.substring(len, acc.value.length),
            arr: [...acc.arr, acc.value.substring(0, len)]
          };
        },
        { value: _value, arr: [] }
      )
      .arr.join(splitChar);
    result = _.trim(result, splitChar);

    if (format.endsWith('*')) {
      if (value.length > format.length) {
        result += _value.substring(format.length - 2);
      }
    }

    if (prefixChar) {
      return prefixChar + result;
    }

    return result;
  };
